import React, { useState, useEffect } from 'react'
import { store } from '../../stores/store'
import { observer } from 'mobx-react'
import IndicatorsPool from '../../js/IndicatorsPool'
import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore';



function Overlay({data, dimensions, country}) {

  const [show, setShow] = useState(null);

  const [transition, setTransition] = useState(false);

  let {file, x, y, visible} = data

  let {scale, offsetLeft, offsetTop} = dimensions

  useEffect(() => {
    // a la fermeture de la report popup
    if(!PopupStore.isOpened(POPUPS_IDS.REPORT)) {
      refresh()
    }


  }, [PopupStore.list]);

  useEffect(() => {
    if(store.yearNumber === 1) {
      refresh()
    }
  }, [store.yearNumber]);

  function refresh() {
    const prevShow = show
    let newShow

    if(typeof visible === "function") {
      newShow = visible(IndicatorsPool)
    }
    else {
      newShow = visible.some(aepid => store.prevSelectedAepIds.indexOf(aepid) > -1)
    }

    if(prevShow !== newShow && prevShow !== null) {
      setTransition(true)
      setTimeout(()=>{
        setTransition(false)
      }, 500)
    }

    setShow(newShow)
  }

  const s = {
    opacity: show ? 1 : 0,
    left: ((x / scale) + offsetLeft)  + "px",
    top: ((y / scale) + offsetTop)  + "px",
    transform: `scale(${(1 / scale)})`
  }



  let cl = "img-overlay"
  cl += transition ? " with-transition" : ""

  const src =  `./images/${country}/${file}`
  return (

    <div className={cl} style={s}>
      <img src={src} />
    </div>

  )
}

export default observer(Overlay)
